import { createSlice } from "@reduxjs/toolkit";
import { reservationService, getReservationService, getReservationPackage, getCoupon, resetCopon, getServicesReservationFromPackage, checkExpiredService, getStoppedPackage, getLoyalPoint } from "./thunk"; // Import the async thunks

const initialState = {
  reservationServiceResponse:null,
  servicesReservationFromPackage:[],
  copon:null,
  loading:false,
  isLoading:false,
  error:null,
  ReservationServices:[], 
  ReservationPackage:[], 
  PackageServicesLoading:false,
  ServiceStatus:null,
  stoppedPackage:[],
  loyalPoint: null
};

const reservationSlice = createSlice({
  name: "reservationSlice",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

      builder
        .addCase(reservationService.pending, (state) => {
          state.loading = true;
        })
        .addCase(reservationService.fulfilled, (state, action) => {
          state.loading = false;
          state.reservationServiceResponse = action.payload
        })
        .addCase(reservationService.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
      builder

        .addCase(getLoyalPoint.fulfilled, (state, action) => {
          state.loyalPoint = action.payload
        })

      builder
        .addCase(getReservationService.pending, (state) => {
          state.loading = true;
          state.ReservationServices = []
        })
        .addCase(getReservationService.fulfilled, (state, action) => {
          state.loading = false;
          state.ReservationServices = action.payload
        })
        .addCase(getReservationService.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });

      builder
        .addCase(getReservationPackage.pending, (state) => {
          state.PackageServicesLoading = true;
          state.ReservationPackage = []
        })
        .addCase(getReservationPackage.fulfilled, (state, action) => {
          state.PackageServicesLoading = false;
          state.ReservationPackage = action.payload
        })
        .addCase(getReservationPackage.rejected, (state, action) => {
          state.PackageServicesLoading = false;
          state.error = action.error.message;
        });
        
      builder
        .addCase(getCoupon.pending, (state) => {
          state.loading = true;
          state.copon = null
        })
        .addCase(getCoupon.fulfilled, (state, action) => {
          state.loading = false;
          state.copon = action.payload
        })
        .addCase(getCoupon.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });

        builder
        .addCase(resetCopon.fulfilled, (state, action) => {
          state.copon = null
        })

        builder
        .addCase(getServicesReservationFromPackage.pending, (state) => {
          state.isLoading = true;
          state.servicesReservationFromPackage = [];
        })
        .addCase(getServicesReservationFromPackage.fulfilled, (state, action) => {
          state.isLoading = false;
          state.servicesReservationFromPackage = action.payload
        })
        .addCase(getServicesReservationFromPackage.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.error.message;
        });
        builder
        .addCase(checkExpiredService.pending, (state) => {
          state.isLoading = true;
          state.ServiceStatus = null;
        })
        .addCase(checkExpiredService.fulfilled, (state, action) => {
          state.isLoading = false;
          state.ServiceStatus = action.payload
        })
        .addCase(checkExpiredService.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.error.message;
        });
        builder
        .addCase(getStoppedPackage.pending, (state) => {
          state.isLoading = true;
          state.stoppedPackage = null;
        })
        .addCase(getStoppedPackage.fulfilled, (state, action) => {
          state.isLoading = false;
          state.stoppedPackage = action.payload
        })
        .addCase(getStoppedPackage.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.error.message;
        });


  },
  

});

export default reservationSlice.reducer;
